import api from '../backAxios';

class VincularLinkGrupo {
    async cadastrarLink(bodylink) {
        try {
            const envioLink = await api.post(
                'tv-telas/links',
                bodylink
            );

            return envioLink.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async putLink(bodylink,id) {
        try {
            const envioLink = await api.put(
                `tv-telas/links/${id}`,
                bodylink
            );

            return envioLink.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async getGruposVinculados(idLink) {
        try {
            const grupos = await api.get(
                `tv-telas/grupos/links-associados?link=${idLink}`
            );

            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async getGruposImagemVinculados(imagemId) {
        try {
            const grupos = await api.get(
                `tv-telas/grupos/links-associados?imagem=${imagemId}`
            );

            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async getLinksVinculadosGrupoId(idGrupo) {
        try {
            const grupos = await api.get(
                `tv-telas/grupos/links-associados?grupo=${idGrupo}`
            );

            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async postLinksVinculadosGrupoId(idGrupo, arrayDadosVincular) {
        try {
            const grupos = await api.post(
                `tv-telas/grupos/associar-link/?grupo=${idGrupo}`, arrayDadosVincular
            );
           
            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async postGrupoVinculadosLinkdId(idLink,gruposVinculados ) {
        try {
            const grupos = await api.post(
                `tv-telas/grupos/associar-link/?link=${idLink}`, gruposVinculados
            );
           
            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async deleteGruposVinculadosLinkId(idLink,gruposDesvinculados) {
        try {
            const grupos = await api.delete(
                `tv-telas/grupos/desassociar-link/?link=${idLink}`, { data: gruposDesvinculados }
            );
            
            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async deleteLinksVinculadosGrupoId(idGrupo, a) {
        try {
            const grupos = await api.delete(
                `tv-telas/grupos/desassociar-link/?grupo=${idGrupo}`, { data: a }
            );
            
            return grupos.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default new VincularLinkGrupo();
